import Vue from 'vue';
// eslint-disable-next-line
export const EventBus = new Vue();
